import { useTranslations } from "next-intl"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment useFormatAgreementNumber_Agreement on AgreementType {
            supplyContractNumber
        }
    `),
}

export function useFormatAgreementNumber() {
    const t = useTranslations("useFormatAgreementNumber")

    return (supplyContract: FragmentOf<typeof graphQLFragments.agreement>) => {
        const { supplyContractNumber } = readFragment(graphQLFragments.agreement, supplyContract)

        return t(`number`, {
            supplyContractNumber,
        })
    }
}

useFormatAgreementNumber.messages = ["useFormatAgreementNumber"] as const

useFormatAgreementNumber.fragments = graphQLFragments
